import React, { FC } from 'react';
import classNames from 'classnames';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';

interface CardContentProps {
  image: ImageDataLike;
  alt: string;
  className?: string;
}

export const CardImage: FC<CardContentProps> = ({ className, image, alt }) => {
  const imageData = getImage(image);

  if (!imageData) return null;

  return (
    <div className={classNames('card__image', className)}>
      <GatsbyImage image={imageData} alt={alt} />
    </div>
  );
};
